import React from 'react';
import { Spinner } from 'react-bootstrap';

import styles from './CustomSpinner.module.scss';

export default (props) => {
  return <Spinner data-testid='spinner' {...props} className={styles[props.className]} />;
};
